import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";
import { z } from "zod";

const createDemoBoardMutation = graphql(/* GraphQL */ `
	mutation CreateDemoBoard($sessionId: String, $campaign: String) {
		demo {
			createBoard(sessionId: $sessionId, campaign: $campaign) {
				demoSessionId
				shareKey
				whiteboardId
				whiteboardUrl
			}
		}
	}
`);

const createDemoBoardResultSchema = z.object({
	demoSessionId: z.string(),
	shareKey: z.string(),
	whiteboardId: z.string(),
	whiteboardUrl: z.string(),
});

export type CreateDemoBoardResult = z.infer<typeof createDemoBoardResultSchema>;

export async function createDemoBoardMutationFn(
	sessionId: string,
	campaign: string,
): Promise<CreateDemoBoardResult | null> {
	const client = getApiClient();
	const response = await client.mutate({
		mutation: createDemoBoardMutation,
		variables: { sessionId, campaign },
		context: { skipAuth: true },
	});

	const createBoard = response.data?.demo?.createBoard;
	if (!createBoard) {
		return null;
	}

	return createDemoBoardResultSchema.parse(createBoard);
}
